(function () {
    let dispatchSearch: HTMLDivElement;
    let listingDataObserver: MutationObserver;
    let initializing = true;
    let closeButton = createCloseButton();
    let showSearchButton = createShowButton();

    function createShowButton() {
        const btn: HTMLButtonElement = document.createElement('button')
        const icon: HTMLSpanElement = document.createElement('span')

        icon.classList.add('far', 'fa-sliders-h', 'ml-3')
        btn.title = 'Filter'
        btn.setAttribute('type', 'button')
        btn.classList.add('btn', 'text-white', 'd-md-none')
        btn.innerText = 'Filter'
        btn.appendChild(icon)

        btn.addEventListener('click', () => {
            showSearch();
        })
        return btn
    }

    function createCloseButton() {
        const btn: HTMLButtonElement = document.createElement('button')
        const icon: HTMLSpanElement = document.createElement('span')

        icon.classList.add('far', 'fa-times', 'ml-3')
        btn.title = 'Close'
        btn.classList.add('btn', 'text-white', 'd-md-none')
        btn.setAttribute('type', 'button')
        btn.innerText = 'Close'
        btn.appendChild(icon)

        btn.addEventListener('click', () => {
            hideSearch()
        })
        return btn
    }

    function hideSearch() {
        dispatchSearch.style.display = 'none';
    }

    function showSearch() {
        dispatchSearch.style.display = 'flex';
    }

    function handleDataLoadingChange() {
        if (initializing) {
            initializing = false;
        }
        else {
            let FeaturedArticle = document.querySelector(".featured");
            if (FeaturedArticle) {
                FeaturedArticle.classList.add("featured-hidden");

                if (listingDataObserver) {
                    listingDataObserver.disconnect();
                }
            }
        }
    }

    $(function () {
        dispatchSearch = document.querySelector('.dispatch-search');

        if (dispatchSearch) {
            const div = document.createElement('div');
            div.classList.add('dispatch-search__control', 'py-0', 'text-right');
            div.appendChild(closeButton);
            dispatchSearch.prepend(div);

            const banner = document.querySelector('.page-hero-banner .container-xxxl');
            if (banner) {
                banner.classList.add('d-flex', 'flex-row', 'justify-content-between');
                banner.appendChild(showSearchButton);
            }
        }

        let listingDataObserver = new MutationObserver(handleDataLoadingChange);
        let listingContainer = document.querySelector(".listing-container");
        if (listingContainer) {
            listingDataObserver.observe(listingContainer, { attributes: true, attributeFilter: ["data-loading"] });
        }
    })
})();
